import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';

/**
 * /affiliates - Lista de TODOS os afiliados.
 */
export default function AffiliatesPage() {
    return <AffiliateList />;
}
